import axios from 'axios';

export default {
  getTesterIP({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersIP/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertTesterIP', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeTesterIP({ commit, state }, platformId) {
    return new Promise((resolve, reject) => {
      commit('removeTesterIPRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersIP/remove`,
        params: { id: platformId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeTesterIPRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeTesterIPRequestError', err);
          reject(err);
        });
    });
  },
  addTesterIP({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('addTesterIPRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersIP/add`,
        params: payload,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addTesterIPRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addTesterIPRequestError', err);
          reject(err);
        });
    });
  },
  addTesterIPArray({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('addTesterIPRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersIP/addArray`,
        data: payload,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addTesterIPArrayRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addTesterIPArrayRequestError', err);
          reject(err);
        });
    });
  },
  editTesterIP({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('editTesterIPRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/testersIP/edit`,
        params: payload,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editTesterIPRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editTesterIPRequestError', err);
          reject(err);
        });
    });
  }
};
